import { Link } from "react-router";
import { SectionHairline } from "../../../ui/waq/SectionHairline";
import { homeTalentBand as band } from "../../../../content/waq/homeTalentBand";

/** A compact light band between Industries and the maturity check. */
export function TalentBand() {
  return (
    <section className="bg-field" aria-labelledby="talent-band-heading">
      <SectionHairline />
      <div className="mx-auto flex max-w-container flex-wrap items-center justify-between gap-x-2col gap-y-6 px-section-x py-section-y">
        <div className="max-w-[760px]">
          <p className="mb-3.5 text-eyebrow font-extrabold uppercase text-blue">{band.eyebrow}</p>
          <h2 id="talent-band-heading" className="mb-3 text-h3 font-extrabold text-navy">
            {band.heading}
          </h2>
          <p className="text-body-lg text-soft">{band.body}</p>
        </div>
        <Link
          to={band.cta.href}
          className="flex-none rounded-btn bg-navy px-[30px] py-[17px] text-btn font-bold text-surface hover:text-surface"
        >
          {band.cta.label}
        </Link>
      </div>
    </section>
  );
}
